import { type AppBundleIdOptionPayload, InventoryContentOption } from '@openx/types/targeting/inventoryAndContent.ts';
import { ComparisonType } from '@openx/types/targeting/targetingValuesTypes.ts';
import type { Dispatch, SetStateAction } from 'react';
import type { Action } from 'redux';
import type { InvalidItemsError } from '../../../shared/BulkAdd/types.ts';
import { setComparisonOpValue } from '../../../shared/InventoryAndContent/inventoryHelpers.ts';
import { separateDuplicates } from './separateDuplicates.ts';

type HandleDuplicateErrorHandlingProps = {
  inventoryListValues: string[];
  inventoryContent: AppBundleIdOptionPayload;
  setAppBundleIdDuplicateErrors: Dispatch<SetStateAction<InvalidItemsError | null>>;
  dispatchInventory: (action: Action) => void;
};

export const handleDuplicateErrorHandling = ({
  inventoryListValues = [],
  inventoryContent,
  setAppBundleIdDuplicateErrors,
  dispatchInventory,
}: HandleDuplicateErrorHandlingProps): void => {
  const inventoryListSet = new Set<string>(inventoryListValues);

  const { duplicates: duplicatesEquals, nonDuplicates: updatedEquals } = separateDuplicates(
    inventoryContent?.val?.[ComparisonType.EQUALS] || [],
    inventoryListSet
  );
  const { duplicates: duplicatesBeginsWith, nonDuplicates: updatedBeginsWith } = separateDuplicates(
    inventoryContent?.val?.[ComparisonType.BEGINS_WITH] || [],
    inventoryListSet
  );

  const allDuplicates = new Set([...duplicatesEquals, ...duplicatesBeginsWith]);

  if (allDuplicates.size > 0) {
    const errors: InvalidItemsError = {
      error: 'Duplicates. Following items have been removed from App Bundle ID manual input',
      invalidItems: [...allDuplicates],
    };

    setAppBundleIdDuplicateErrors(errors);

    const updatedValues: AppBundleIdOptionPayload['val'] = {
      ...(updatedEquals.length > 0 ? { [ComparisonType.EQUALS]: updatedEquals } : {}),
      ...(updatedBeginsWith.length > 0 ? { [ComparisonType.BEGINS_WITH]: updatedBeginsWith } : {}),
    };

    dispatchInventory(
      setComparisonOpValue[InventoryContentOption.APP_BUNDLE_ID]({
        values: updatedValues,
      })
    );

    return;
  }

  setAppBundleIdDuplicateErrors(null);
};
